import { render } from "./BottomBox.vue?vue&type=template&id=18242b05&scoped=true"
const script = {}

import "./BottomBox.vue?vue&type=style&index=0&id=18242b05&scoped=true&lang=css"

import exportComponent from "D:\\zirrowen2\\zirrowen2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18242b05"]])

export default __exports__